export const CHANGE_ACTIVE_BRAND = 'CHANGE_ACTIVE_BRAND';

export const changeActiveBrand = text => ({
    type: CHANGE_ACTIVE_BRAND,
    payload: text
});
